import {
  PaymentByProps,
  PaymentMethodsProps,
} from "_interfaces/_common/payment";
import React from "react";

export interface PaymentOptionsListProps {
  label: string;
  paymentMethod: PaymentMethodsProps;
  paymentBy: PaymentByProps;
  Icon?: React.ElementType;
  disabled?: boolean;
}
export const paymentOptionsList: PaymentOptionsListProps[] = [
  {
    label: "MTN Momo",
    paymentMethod: "mobileMoney",
    paymentBy: "momo",
    // Icon: MonetizationOnOutlinedIcon,
    disabled: false,
  },
  {
    label: "Airtel Money",
    paymentMethod: "mobileMoney",
    paymentBy: "airtelMoney",
    // Icon: MonetizationOnOutlinedIcon,
    disabled: false,
  },
  // {
  //   label: "Wallet",
  //   // Icon: AccountBalanceWalletIcon,
  //   paymentMethod: "mobileMoney",
  //   paymentBy: "wallet",
  //   disabled: false,
  // },
  // {
  //   label: "Installment",
  //   Icon: CalendarMonthOutlinedIcon,
  //   paymentMethod: "installment",
  //   paymentBy: "installment",
  //   disabled: true,
  // },
  // {
  //   label: "Credit / Debit Card",
  //   Icon: CreditCardIcon,
  //   paymentMethod: "creditCard",
  //   paymentBy: "creditCard",
  //   disabled: true,
  // },
  // { label: "Mobile Money", Icon: MonetizationOnOutlinedIcon },
  // { label: "Other", Icon: CircleOutlinedIcon },
];
